import { Component, Vue, Mixins, Prop } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import { OCMailAuthenticationResponse } from '@/components/OCMailAuthentication';

@Component({
    components: AllComponents(),
})
export default class SignUp extends Mixins(CommonView) {

    type: "signup" | "reminder" = "signup";
    mailAuthentication: OCMailAuthenticationResponse | null = null;

    public async created() {
        if (this.$route.path === '/reminder') {
            this.type = "reminder";
        }
    }

    public reminder(val: OCMailAuthenticationResponse) {
        this.mailAuthentication = val;
        this.type = "reminder";
    }

    public signup(val: OCMailAuthenticationResponse) {
        this.mailAuthentication = val;
        this.type = "signup";
    }
}

